import { EBusinessType } from '../../../../shared/types/businessType';

const types = [
  {
    name: 'Офис',
    genitiveName: 'Офиса',
    key: 'office',
  },
  {
    name: 'Здание',
    genitiveName: 'Здания',
    key: 'building',
  },
  {
    name: 'Торговая площадь',
    genitiveName: 'Торговой площади',
    key: 'shoppingArea',
  },
  {
    name: 'Помещение свободного назначения',
    genitiveName: 'Помещения свободного назначения',
    key: 'freeAppointmentObject',
  },
  {
    name: 'Производство',
    genitiveName: 'Производства',
    key: 'industry',
  },
  {
    name: 'Склад',
    genitiveName: 'Склада',
    key: 'warehouse',
  },
  {
    name: 'Гараж',
    genitiveName: 'Гаража',
    key: 'garage',
  },
  {
    name: 'Бизнес',
    genitiveName: 'Бизнеса',
    key: 'business',
  },
  {
    name: 'Коммерческая земля',
    genitiveName: 'Коммерческой земли',
    key: 'commercialLand',
  },
];

// eslint-disable-next-line import/no-default-export
export default types;

const typesWithoutBusiness = types.filter(type => type.key !== 'business');

const typeCoworking = {
  name: 'Коворкинг',
  genitiveName: 'Коворкинга',
  key: 'coworking',
};

export const commercialRentTypes = [...[typesWithoutBusiness[0], typeCoworking], ...typesWithoutBusiness.slice(1)];

export const coworkingSubTypes = [
  {
    name: 'Отдельный офис',
    genitiveName: 'Отдельного офиса',
    key: 'office',
  },
  {
    name: 'Закреплённое рабочее место',
    genitiveName: 'Закреплённого рабочего места',
    key: 'fixedWorkplace',
  },
  {
    name: 'Незакреплённое рабочее место',
    genitiveName: 'Незакреплённого рабочего места',
    key: 'flexibleWorkplace',
  },
];

export const coworkingAnalyticSubTypes = {
  office: 'flexible_office',
  fixedWorkplace: 'fixed_workplace',
  flexibleWorkplace: 'unfixed_workplace',
  conferenceHall: 'conference_hall',
  meetingRoom: 'meeting_room',
};

export const businessSubTypes = [
  {
    key: EBusinessType.RentalBusiness,
    name: 'Арендный бизнес',
    genitiveName: 'Арендного бизнеса',
    description: 'Помещение в собственности с\u00A0арендатором на\u00A0долгий срок',
  },
  {
    key: EBusinessType.ReadyBusiness,
    name: 'Готовый бизнес',
    genitiveName: 'Готового бизнеса',
    description: 'Помещение в собственности или аренде с\u00A0юрлицом, имуществом и\u00A0сотрудниками',
  },
];
